import React from 'react';
import './about.css';
import Back from '../common/Back';
import img from "../images/about.jpg"
import Heading from '../common/Heading';

function About() {
  return (
    <>
      <section className='about'>
        <Back name="About Us" title="About Us - Who We Are?" cover={img} />
        <div className='container flex mtop'>
          <div className='left row'>
            <Heading title='Our Agency Story' subtitle='Check out our company story and work process' />
            <p>
              For the past 8 years, A.K Properties has been a cornerstone in the real estate industry, dedicated to
              facilitating seamless transactions in buying, selling, and renting properties. Our commitment to
              excellence and customer satisfaction has positioned us as a trusted partner for countless clients
              seeking to navigate the complex real estate market.
            </p>

            <p>
              Our team of experienced professionals works tirelessly to ensure that each client receives
              personalized attention and tailored solutions that meet their unique needs. We pride ourselves
              on our in-depth market knowledge, robust negotiation skills, and a comprehensive approach to
              property management that delivers results and peace of mind.
            </p>

            <button className='btn2'>More About Us</button>
          </div>
          <div className='right row'>
            <img src='./immio1.jpg' alt='' />
          </div>
        </div>
      </section>
    </>
  )
}

export default About;
